import type {
  JobClosureRatingListType,
  SingleApprovalDataType,
  SingleScheduledUpcomingInterviewsDetailsType,
  ThinksToDoType,
} from "@/redux/thinksToDo/thinksToDoType";

export const initialState: ThinksToDoType = {
  fetching: false,
  message: null,
  updateFetching: false,
  error: null,
  success: null,
  statusCode: null,
  scheduledUpcomingInterviews: [],
  singleScheduledUpcomingInterviewsDetails:
    {} as SingleScheduledUpcomingInterviewsDetailsType,
  totalCount: 0,
  singleApprovalData: {} as SingleApprovalDataType,
  jobClosureListData: [],
  jobClosureListForRM: [],
  jobClosureRatingList: {} as JobClosureRatingListType,
  totalCountRM: 0,
  jobClosureTotalCount: 0,
  unApprovedInvoiceCountData: [],
  regularizeApprovalPendingList: [],
  unApprovedInvoiceTotalCount: 0,
  isAccountingInCharge: 0,
  approvedInvoiceTotalCount: 0,
  usersWeeklyApprovedInvoiceTotalCount: 0,
};
